import axios from "axios"

const actionGetEvents = async () => {
    const events = await axios.get(`${process.env.VUE_APP_URL_API}/v1/events/`);
    return events.data;
}

export default {
    actionGetEvents
}